<template>
  <div class="mention-page">
    <HeaderPage :page="currentPageInfo" />
    <div
      class="content"
      v-html="content || ''"
    />
  </div>
</template>

<script setup lang="ts">
import type { Endpoints } from '@/types'

const route = useRoute()

const { data, error } = await useCustomFetch<Endpoints['GET__PAGE']>(
  `${API.GET__PAGE}/${route.params.pageName}`,
)

if (error.value || !data.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page introuvable' })
}

const { title, description, content } = data.value

const currentPageInfo = {
  titleBig: title,
  image: '/img/mentions_legales.jpg',
}

useHead({
  title,
})

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://www.weareplaystation.fr/img/mentions_legales.jpg',
})
</script>

<style lang="scss">
.mention-page {
  .content {
    max-width: 95.2rem;
    margin: auto;
    padding: 8rem;

    h2 {
      margin: 6rem 0 4rem;
      font-family: SST;
      font-size: 2rem;
      font-weight: bold;
      line-height: 2.4rem;
      letter-spacing: 0;

      &:first-child {
        margin-top: 0;
      }
    }

    ul {
      padding: 2rem;
      list-style: disc;
    }

    ol {
      padding: 2rem;
    }

    img {
      width: 100%;
      height: auto;
      margin-top: 4rem;
      margin-bottom: 4rem;
    }

    a {
      color: $blue;
    }
  }
}

@media screen and (max-width: 700px) {
  .mention-page {
    .content {
      padding: 5rem 2.5rem;
    }
  }
}
</style>
